/* eslint-disable @next/next/no-img-element */
import { FC, useEffect } from 'react';

import { useRouter } from 'next/router';

import { useCustomTheme } from '~/common/providers/theme';
import { useBusiness } from '~/common/providers/business';
import { useMediaQuery } from '~/common/hooks/use-media-query';
import { getBusinessLogo } from '~/common/constants/vmcore-brand';
import { MonteiroEngenhariaLogo } from '~/common/components/MonteiroEngenhariaLogo';

import { VersionButton } from './VersionButton';
import { SidebarContainer, SidebarFooter, StyDrawerMUI } from './styles';
import { SidebarMenu } from './Menu';

export interface ISidebarProps {
  closeMobileSidebar?: () => void;
  openSidebarDrawer?: boolean;
  setOpenSidebarDrawer?: (open: boolean) => void;
}

export const Sidebar: FC<ISidebarProps> = ({
  closeMobileSidebar,
  openSidebarDrawer,
  setOpenSidebarDrawer,
}) => {
  const { business } = useBusiness();
  const { themeOption } = useCustomTheme();
  const businessLogo = getBusinessLogo(
    business,
    themeOption === 'dark' ? 'light' : 'dark'
  );
  const { asPath } = useRouter();

  const isSmallScreen = useMediaQuery('(max-width: 1279px)');

  useEffect(() => {
    if (isSmallScreen && setOpenSidebarDrawer) {
      setOpenSidebarDrawer(false);
    }

    if (closeMobileSidebar) {
      closeMobileSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asPath]);

  if (isSmallScreen) {
    return (
      <StyDrawerMUI
        id="sidebar-id"
        anchor="left"
        open={openSidebarDrawer}
        onClose={() => setOpenSidebarDrawer(!openSidebarDrawer)}
        aria-hidden={false}
      >
        <SidebarContainer themeOption={themeOption}>
          <MonteiroEngenhariaLogo
            width={180}
            height={44}
            src={businessLogo}
            alt={business?.nome || 'Monteiro Engenharia'}
            showCloseButton={isSmallScreen}
            openSidebarDrawer={openSidebarDrawer}
            setOpenSidebarDrawer={() =>
              setOpenSidebarDrawer(!openSidebarDrawer)
            }
          />
          <SidebarMenu />
          <SidebarFooter>
            <VersionButton />
          </SidebarFooter>
        </SidebarContainer>
      </StyDrawerMUI>
    );
  }

  return (
    <SidebarContainer themeOption={themeOption}>
      <MonteiroEngenhariaLogo
        width={180}
        height={44}
        src={businessLogo}
        alt={business?.nome || 'Monteiro Engenharia'}
      />
      <SidebarMenu />
      <SidebarFooter>
        <VersionButton />
      </SidebarFooter>
    </SidebarContainer>
  );
};
